import { InjectionToken } from '@angular/core';
import { AuthUser } from '../models/auth-user';

export const IAUTHSERVICE = new InjectionToken<IAuthService>('title');

export interface IAuthService {
  loggedIn: boolean;
  userInfo: any;
  isIframe: boolean;
  app: any;

  switchUser();
  logout();
  authuser(): AuthUser;
  renderButtonSwitch(btnId: string);
}
